import {
  Query_Series,
  Query_Series_Series_seasons_episodes,
} from '@yi/core/src/gql/generated/typesClient';

export function getEpisodesOrder(
  seriesDetails: Query_Series,
): Query_Series_Series_seasons_episodes[] {
  const seasons = seriesDetails.Series.seasons;

  const allSeasonsEpisodes = seasons.map(item => item.episodes).flat();
  return allSeasonsEpisodes;
}
